export const galleryMedia = [
    {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0208.MP4',
    type: 'video',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7567.MP4',
    type: 'video',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7568.MP4',
    type: 'video',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7569.MP4',
    type: 'video',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7571.MP4',
    type: 'video',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0208.MP4',
    type: 'video',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/74007788065__2041642A-ACF7-4885-B357-AD163BE16EE9.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/74200207512__E53DCA8E-7391-4CEF-84A5-8124EDE76BE7.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0082.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0083.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0084.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0085.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0086.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0087.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0088.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0089.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0090.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0091.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0092.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_0984.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_2559.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_2560.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_2653.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_2667.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_2733.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_2737.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_3509.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_5141.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_5366.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_5476.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_5627.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_6551.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_6819.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7538.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7561.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7562.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7563.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7564.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7660.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7676.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7692.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7695.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7700.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7714.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7727.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7730.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7778.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7856.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7859.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7862.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7873.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7875.JPG',
    type: 'image',
  },
  { url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7884.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7892.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7932.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7934.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7943.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_7944.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8098.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8639.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8641.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8644.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8714.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8745.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8752.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8754.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8836.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8837.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8850.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8883.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8888.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8889.JPG',
    type: 'image',
  },
  { 
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8904.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_8908.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9006.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9007.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9010.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9013.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9020.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9023.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9091.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9094.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9271.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9274.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9275.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9285.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9291.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9293.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9302.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9575.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9576.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/IMG_9578.JPG',
    type: 'image',
  },
  {
    url: 'https://salm-images.s3.us-east-1.amazonaws.com/news_12082023.png',
    type: 'image',
  },
];